import homeIcon from '@iconify/icons-ant-design/home-outline';
import React from 'react';
import { cssVars } from '@/app/styles';
import { onlinePlatforms } from '@/constants';
import { numberWithCommas } from '@/utils/string-utils';
import styled from 'styled-components';
import { HeaderSm } from './header-sm';
import * as kpi from './kpi-styles';

const ValueWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

function buildOnlinePlatformLabels(latestKpi) {
  const LABEL = 0;
  const DATA = 1;
  const TOP_THREE = 3;
  const sortedPlatforms = Object.entries(latestKpi).sort(
    (a, b) => b[DATA].value - a[DATA].value
  );
  const sortedLabels = [];
  let others = 0;
  for (let i = 0; i < sortedPlatforms.length; i++) {
    if (i >= TOP_THREE) {
      // Calculate Others
      others += sortedPlatforms[i][DATA].value;
    } else {
      // Top 3
      const FIRST_LETTER = 0;
      const REMAINING = 1;
      let label = sortedPlatforms[i][LABEL];
      label = label[FIRST_LETTER].toUpperCase() + label.slice(REMAINING);
      sortedLabels.push({
        label,
        value: sortedPlatforms[i][DATA].value,
      });
    }
  }
  // Push Others
  sortedLabels.push({
    label: 'Others',
    value: others,
  });
  return sortedLabels;
}

/**
 * Header component for key performance indicators for online platforms (for small cards)
 * @param {number} props.airbnb
 * @param {number} props.vrbo
 * @param {number} props.booking
 * @param {number} props.others
 */
export function KpiOnlinePlatforms(props) {
  const { latestKpi, marginUnderLabel } = props;
  const labels = buildOnlinePlatformLabels(latestKpi);
  const order = {
    FIRST: 0,
    SECOND: 1,
    THIRD: 2,
    OTHERS: 3,
  };
  return (
    <HeaderSm marginUnderLabel={marginUnderLabel} label="Online Platforms">
      <div>
        <kpi.ColumnLabelSm
          color={cssVars.color[labels[order.FIRST].label.toLowerCase()]}
        >
          {labels[order.FIRST].label}
        </kpi.ColumnLabelSm>
        <ValueWrapper>
          <kpi.ColumnValueSm>
            {numberWithCommas(labels[order.FIRST].value)}
          </kpi.ColumnValueSm>
          <kpi.IconHome icon={homeIcon} />
        </ValueWrapper>
      </div>
      <div>
        <kpi.ColumnLabelSm
          color={cssVars.color[labels[order.SECOND].label.toLowerCase()]}
        >
          {labels[order.SECOND].label}
        </kpi.ColumnLabelSm>
        <ValueWrapper>
          <kpi.ColumnValueSm>
            {numberWithCommas(labels[order.SECOND].value)}
          </kpi.ColumnValueSm>
          <kpi.IconHome icon={homeIcon} />
        </ValueWrapper>
      </div>

      <div>
        <kpi.ColumnLabelSm
          color={cssVars.color[labels[order.THIRD].label.toLowerCase()]}
        >
          {labels[order.THIRD].label}
        </kpi.ColumnLabelSm>
        <ValueWrapper>
          <kpi.ColumnValueSm>
            {numberWithCommas(labels[order.THIRD].value)}
          </kpi.ColumnValueSm>
          <kpi.IconHome icon={homeIcon} />
        </ValueWrapper>
      </div>
      <div>
        <kpi.ColumnLabelSm color={cssVars.color[onlinePlatforms.OTHERS]}>
          {labels[order.OTHERS].label}
        </kpi.ColumnLabelSm>
        <ValueWrapper>
          <kpi.ColumnValueSm>
            {numberWithCommas(labels[order.OTHERS].value)}
          </kpi.ColumnValueSm>
          <kpi.IconHome icon={homeIcon} />
        </ValueWrapper>
      </div>
    </HeaderSm>
  );
}
